import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { APIForm } from './APIForm';
export function Footer() {
  const [isAPIFormOpen, setIsAPIFormOpen] = useState(false);
  const navigate = useNavigate();
  // Handle smooth navigation to new pages
  const handleNavigation = (e, path) => {
    e.preventDefault();
    // If it's a hash link on the same page, use native smooth scroll
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // For navigation to different pages
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // After smooth scroll animation completes, navigate to the new page
    setTimeout(() => {
      navigate(path);
    }, 500); // Adjust timing based on scroll animation duration
  };
  return <footer className="bg-gray-900 text-white" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-177">
          <div data-id="element-178">
            <h3 className="text-xl font-bold mb-4" data-id="element-179">agentter.ai</h3>
            <p className="text-gray-400" data-id="element-180">
              Building AI agents for your business has never been easier.
            </p>
            <div className="mt-4 flex space-x-4" data-id="element-181">
              <a href="https://www.linkedin.com/company/agentter/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-182">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-183">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-184" />
                </svg>
              </a>
              <a href="https://twitter.com/agentter" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="X (Twitter)" data-id="element-185">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-186">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-187" />
                </svg>
              </a>
              <a href="https://www.instagram.com/agentter.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-188">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-189">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-190" />
                </svg>
              </a>
              <a href="https://github.com/agentter.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="GitHub" data-id="element-191">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-192">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-193" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-194">
            <h3 className="text-lg font-semibold mb-4" data-id="element-195">Product</h3>
            <ul className="space-y-2" data-id="element-196">
              <li data-id="element-197">
                <a href="/#features" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#features')} data-id="element-198">
                  Features
                </a>
              </li>
              <li data-id="element-199">
                <a href="/pricing" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/pricing')} data-id="element-200">
                  Pricing
                </a>
              </li>
              <li data-id="element-201">
                <a href="/#agent-gallery" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#agent-gallery')} data-id="element-202">
                  Case Studies
                </a>
              </li>
              <li data-id="element-203">
                <a href="/#how-it-works" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#how-it-works')} data-id="element-204">
                  Documentation
                </a>
              </li>
              <li data-id="element-205">
                <button onClick={() => setIsAPIFormOpen(true)} className="text-gray-400 hover:text-white transition-colors" data-id="element-206">
                  API
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-207">
            <h3 className="text-lg font-semibold mb-4" data-id="element-208">Solutions</h3>
            <ul className="space-y-2" data-id="element-209">
              <li data-id="element-210">
                <a href="/solutions/freight" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/solutions/freight')} data-id="element-211">
                  Freight Companies
                </a>
              </li>
              <li data-id="element-212">
                <a href="/solutions/shipping" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/solutions/shipping')} data-id="element-213">
                  Shipping
                </a>
              </li>
              <li data-id="element-214">
                <a href="/solutions/construction" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/solutions/construction')} data-id="element-215">
                  Construction
                </a>
              </li>
              <li data-id="element-216">
                <a href="/solutions/healthcare" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/solutions/healthcare')} data-id="element-217">
                  Healthcare
                </a>
              </li>
              <li data-id="element-218">
                <a href="/solutions/finance" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/solutions/finance')} data-id="element-219">
                  Finance
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-220">
            <h3 className="text-lg font-semibold mb-4" data-id="element-221">Company</h3>
            <ul className="space-y-2" data-id="element-222">
              <li data-id="element-223">
                <a href="/about" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/about')} data-id="element-224">
                  About
                </a>
              </li>
              <li data-id="element-225">
                <a href="/#cta" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#cta')} data-id="element-226">
                  Blog
                </a>
              </li>
              <li data-id="element-227">
                <a href="/#cta" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#cta')} data-id="element-228">
                  Careers
                </a>
              </li>
              <li data-id="element-229">
                <a href="/contact" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/contact')} data-id="element-230">
                  Contact
                </a>
              </li>
              <li data-id="element-231">
                <a href="/#cta" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#cta')} data-id="element-232">
                  Partners
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-233">
          <p className="text-gray-400" data-id="element-234">
            © 2025 Agentter.ai. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-235">
            <a href="/#" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#')} data-id="element-236">
              Privacy Policy
            </a>
            <a href="/#" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#')} data-id="element-237">
              Terms of Service
            </a>
            <a href="/#" className="text-gray-400 hover:text-white transition-colors" onClick={e => handleNavigation(e, '/#')} data-id="element-238">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
      <APIForm isOpen={isAPIFormOpen} onClose={() => setIsAPIFormOpen(false)} data-id="element-239" />
    </footer>;
}